import { render, staticRenderFns } from "./SystemAssessmentList.vue?vue&type=template&id=27ae6aa0&scoped=true"
import script from "./SystemAssessmentList.vue?vue&type=script&lang=js"
export * from "./SystemAssessmentList.vue?vue&type=script&lang=js"
import style0 from "./SystemAssessmentList.vue?vue&type=style&index=0&id=27ae6aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae6aa0",
  null
  
)

export default component.exports